module.exports = __webpack_public_path__ + "static/media/33-signal.1a8ff210.jpg";